<template>
  <donut-modal-sections-title title="Are you sure?" />
  <p class="t-lg">
    This value has previously been used in
    {{ capitalize($i18n.t('shoutouts.feature')) }}. If you delete it, any future
    {{ $i18n.t('shoutouts.shoutout.other') }} with this value will no longer
    have an effect. This value will also not show on the
    <a class="link t-lg" href="/shoutouts/leaderboard" target="_blank">Leaderboard</a>
    page.
  </p>
  <template v-if="examples?.length > 0">
    <p class="t-lg m-tx1 bold m-tx2">Example usages:</p>
    <ul class="d-b m-tx1 f f-v f-gap-4 f-ast">
      <li v-for="(record, rIdx) in examples" :key="rIdx" class="m-t0">
        <shoutouts-profiles-wall-card
          :key="`record-${rIdx}`"
          class="profile-wall-card-overrides"
          :shoutout="record"
        />
      </li>
    </ul>
  </template>
  <donut-modal-sections-actions
    button-text="Delete"
    :loading-on-save="true"
    :simulate-loading-on-save="true"
    :is-warning="true"
    :save-args="{}"
    :save-tracking="{}"
    :is-save-disabled="false"
    @save="onSave"
  />
</template>
<script setup>
import { computed, onMounted, inject } from 'vue';
import { useStore } from 'vuex';
import { capitalize } from 'lodash';
import { useUsageExamples, fetchUsageExamples } from './module';

const $i18n = inject('$i18n');

const { state, commit } = useStore();
const tagId = computed(() => state.modal.data.tagId);
const onConfirm = computed(() => state.modal.data.onConfirm);
const examples = useUsageExamples(tagId.value);

const onSave = () => {
  onConfirm.value({
    onComplete: () => commit('closeModal'),
  });
};

onMounted(() => {
  fetchUsageExamples(tagId.value);
});
</script>

<style>
.profile-wall-card-overrides .profile-wall-card {
  width: 100%;
}
</style>
